// extracted by mini-css-extract-plugin
export default {"block":"DaUAR","heading-title":"DoM24","tabs":"rMqEP","tabs-group":"eMlJe"};